import { FilterByNumber } from '../../../../types/types';
import { IonRange, IonText } from '@ionic/react';
import { FilterData } from '../../../FilterForm/FilterForm';

interface IFilterNumberProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByNumber;
  filterData?: FilterData;
}

export default function FilterNumber({
  onChange,
  filter,
  filterData,
}: IFilterNumberProps) {
  const rangeValue = filterData?.values
    ? filterData.values[0] || undefined
    : undefined;
  const { minValue, maxValue } = filter;

  const handleChange = ({ detail: { value } }: CustomEvent) => {
    onChange({ id: filter.id, values: [value.toString()] });
  };

  return (
    <div className="ion-padding">
      <IonText color={'primary'}>{rangeValue}</IonText>
      <IonRange
        debounce={200}
        value={Number(rangeValue)}
        max={maxValue}
        min={minValue}
        onIonChange={handleChange}
      />
    </div>
  );
}
